import MagstimTableTreatmentTemplateBase from './MagstimTableTreatmentTemplateBase';

class MagstimTableTreatmentTemplate extends MagstimTableTreatmentTemplateBase {
	initImpl(configData, heightPx) {
		this.initTable(configData, heightPx);
	}
}

export default MagstimTableTreatmentTemplate;